import { NavLink } from "react-router";

export const Nav = () => {
    return (
        <>
            <nav className="flex w-full border-solid p-2 justify-center">
                <div className="flex w-1/5 gap-4">
                    <NavLink to="/" end>
                        <h2 className="text-2xl flex">
                            London property pulse
                        </h2>
                    </NavLink>
                    <strong>BETA</strong>
                </div>
                <div className="flex w-4/5 align-middle">
                    <div className="flex justify-evenly w-full align-middle">
                        <NavLink className="hover:underline" to="/search">Search</NavLink>
                        <NavLink className="hover:underline" to="/charts" end>
                            Market
                        </NavLink>
                        <NavLink className="hover:underline" to="/about">About</NavLink>
                        <NavLink className="hover:underline" to="/contact">Contact</NavLink>
                        <NavLink className="hover:underline" to="/signup">Sign up</NavLink>
                        <NavLink className="hover:underline" to="/login">Login</NavLink>
                    </div>
                </div>
            </nav>
        </>
    );
}